import { TemplateRef } from '@angular/core';

export interface RRIStepper {
  stepId: number;
  stepName: string;
  isActive?: boolean;
  order: number;
  template: TemplateRef<any>;
}
